import React, { useEffect, useState } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Card,
  CardBody,
  Spinner
} from "reactstrap";
import Select from "react-select";
import { Trash } from "react-feather";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";

// import { API_URL } from "../../../Config/secrets";
// import { uploadFileToBucket } from "../../../Utils";
import { age, market, price, product_category, style, target_group, wholesale_group } from "../../../static/brands_wholesalers_data";

const createValidationSchema = () => {
  return yup.object().shape({
    brands: yup.array().of(
      yup.object().shape({
        name: yup.string().required(),
        website: yup.string().url().required(),
        logo: yup.mixed(),
        wholesale_group: yup.array(),
        market: yup.array(),
        age: yup.array(),
        product_category: yup.array(),
        target_group: yup.array(),
        price: yup.array(),
        style: yup.array(),
        preferred_market: yup.array(),
        facebook: yup.string().url().nullable(),
        instagram: yup.string().url().nullable(),
        linkedin: yup.string().url().nullable()
      })
    ),
    wholesalers: yup.array().of(
      yup.object().shape({
        name: yup.string().required(),
        website: yup.string().url().required(),
        logo: yup.mixed(),
        wholesale_group: yup.array(),
        market: yup.array(),
        age: yup.array(),
        product_category: yup.array(),
        target_group: yup.array(),
        price: yup.array(),
        style: yup.array(),
        preferred_market: yup.array(),
        facebook: yup.string().url().nullable(),
        instagram: yup.string().url().nullable(),
        linkedin: yup.string().url().nullable()
      })
    ),
    retailers: yup.array().of(
      yup.object().shape({
        name: yup.string().required(),
        website: yup.string().url().required(),
        logo: yup.mixed(),
        wholesale_group: yup.array(),
        market: yup.array(),
        age: yup.array(),
        product_category: yup.array(),
        target_group: yup.array(),
        price: yup.array(),
        style: yup.array(),
        preferred_market: yup.array(),
        facebook: yup.string().url().nullable(),
        instagram: yup.string().url().nullable(),
        linkedin: yup.string().url().nullable()
      })
    )
  });
};

const options = {
  wholesale_group: wholesale_group,
  market: market,
  age: age,
  product_category: product_category,
  target_group: target_group,
  price: price,
  style: style,
  preferred_market: market,
};

const arrayFields = ['wholesale_group', "market", "age", "product_category", "target_group", "price", "style", "preferred_market"];

const FormFields = ({ fields, control, errors, namePrefix, onRemove }) => {
  return fields.map((item, index) => (
    <Card key={item.id} className="mb-3 rounded-0 border-top">
      <CardBody>
        <div className="row">
          <div className="col-md-6">
            <FormGroup>
              <Label>Name *</Label>
              <Controller
                name={`${namePrefix}.${index}.name`}
                control={control}
                render={({ field }) => (
                  <Input invalid={!!errors?.[index]?.name} {...field} />
                )}
              />
              {errors?.[index]?.name && <FormFeedback>{errors[index].name.message}</FormFeedback>}
            </FormGroup>
          </div>
          <div className="col-md-6">
            <FormGroup>
              <Label>Website *</Label>
              <Controller
                name={`${namePrefix}.${index}.website`}
                control={control}
                render={({ field }) => (
                  <Input type="url" invalid={!!errors?.[index]?.website} {...field} />
                )}
              />
              {errors?.[index]?.website && <FormFeedback>{errors[index].website.message}</FormFeedback>}
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <FormGroup>
              <Label>Logo</Label>
              <Controller
                name={`${namePrefix}.${index}.logo`}
                control={control}
                render={({ field: { value, onChange, ...field } }) => (
                  <Input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => onChange(e.target.files[0])}
                    invalid={!!errors?.[index]?.logo}
                    {...field}
                  />
                )}
              />
            </FormGroup>
          </div>
          <div className="col-md-6">
            <FormGroup>
              <Label>Wholesale Group</Label>
              <Controller
                name={`${namePrefix}.${index}.wholesale_group`}
                control={control}
                render={({ field }) => (
                  <Select
                    isMulti
                    options={options['wholesale_group']?.map((c) => ({ value: c?.label, label: c?.label }))}
                    value={field.value}
                    onChange={(val) => field.onChange(val)}
                  />
                )}
              />
            </FormGroup>
          </div>
        </div>
        {arrayFields?.slice(1).map((key) => (
          <FormGroup key={key}>
            <Label>{key.replace("_", " ").toUpperCase()}</Label>
            <Controller
              name={`${namePrefix}.${index}.${key}`}
              control={control}
              render={({ field }) => (
                <Select
                  isMulti
                  options={options[key]?.map((c) => ({ value: c?.label, label: c?.label }))}
                  value={field.value}
                  onChange={(val) => field.onChange(val)}
                />
              )}
            />
          </FormGroup>
        ))}
        <div className="row">
          <div className="col-md-4">
            <FormGroup>
              <Label>Facebook</Label>
              <Controller
                name={`${namePrefix}.${index}.facebook`}
                control={control}
                render={({ field }) => (
                  <Input type="url" {...field} />
                )}
              />
            </FormGroup>
          </div>
          <div className="col-md-4">
            <FormGroup>
              <Label>Instagram</Label>
              <Controller
                name={`${namePrefix}.${index}.instagram`}
                control={control}
                render={({ field }) => (
                  <Input type="url" {...field} />
                )}
              />
            </FormGroup>
          </div>
          <div className="col-md-4">
            <FormGroup>
              <Label>LinkedIn</Label>
              <Controller
                name={`${namePrefix}.${index}.linkedin`}
                control={control}
                render={({ field }) => (
                  <Input type="url" {...field} />
                )}
              />
            </FormGroup>
          </div>
        </div>
      </CardBody>
      <div className="d-flex" onClick={() => onRemove(index)}>
        <Button>Delete <Trash /></Button>
      </div>
    </Card>
  ));
};

const UploadManually = ({ onSubmit }) => {
  const [openAccordion, setOpenAccordion] = useState("1");

  const { control, handleSubmit, getValues, formState: { isSubmitting, errors } } = useForm({
    resolver: yupResolver(createValidationSchema()),
    defaultValues: {
      brands: [{}],
      wholesalers: [],
      retailers: []
    }
  });

  useEffect(() => { }, [errors]);

  const {
    remove: brandRemove,
    fields: brandFields,
    append: appendBrand
  } = useFieldArray({ control, name: "brands" });

  // const {
  //   remove: wholesalerRemove,
  //   fields: wholesalerFields,
  //   append: appendWholesaler
  // } = useFieldArray({ control, name: "wholesalers" });

  const {
    remove: retailerRemove,
    fields: retailerFields,
    append: appendRetailer
  } = useFieldArray({ control, name: "retailers" });

  const toggle = (id) => {
    setOpenAccordion(openAccordion === id ? "" : id);
  };

  const _handleSubmit = async (data) => {
    await onSubmit(data);
  };

  const handleSkip = async () => {
    await onSubmit();
  }

  return (
    <Form onSubmit={handleSubmit(_handleSubmit)}>
      <Accordion open={openAccordion} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader targetId="1">Brands</AccordionHeader>
          <AccordionBody accordionId="1">
            <Button color="success" onClick={() => appendBrand({})} className="mb-3">
              Add Brand
            </Button>
            <FormFields fields={brandFields} control={control} errors={errors.brands} namePrefix="brands" onRemove={index => brandRemove(index)} />
          </AccordionBody>
        </AccordionItem>
        {/* <AccordionItem>
          <AccordionHeader targetId="2">Wholesalers</AccordionHeader>
          <AccordionBody accordionId="2">
            <Button color="success" onClick={() => appendWholesaler({})} className="mb-3">
              Add Wholesaler
            </Button>
            <FormFields fields={wholesalerFields} control={control} errors={errors.wholesalers} namePrefix="wholesalers" onRemove={index => wholesalerRemove(index)} />
          </AccordionBody>
        </AccordionItem> */}
        <AccordionItem>
          <AccordionHeader targetId="3">Retailers</AccordionHeader>
          <AccordionBody accordionId="3">
            <Button color="success" onClick={() => appendRetailer({})} className="mb-3">
              Add Retailer
            </Button>
            <FormFields fields={retailerFields} control={control} errors={errors.retailers} namePrefix="retailers" onRemove={index => retailerRemove(index)} />
          </AccordionBody>
        </AccordionItem>
      </Accordion>

      <div className="d-flex justify-content-center gap-3 mt-4">
        <Button color="primary" outline type="submit" disabled={isSubmitting} onClick={handleSkip} className="mt-4">
          Skip
        </Button>
        <Button color="primary" type="submit" disabled={isSubmitting} className="mt-4">
          Submit {isSubmitting && <Spinner size='sm' />}
        </Button>
      </div>
    </Form>
  );
};

export default UploadManually;
